import React from "react";
import ItemDocument from "./ItemDocument";
import { Checkbox } from "@material-ui/core";

function ItemRequiredReadingDocument(props) {
  return (
    <ItemDocument
      {...props}
      noIcons
      preText={
        <Checkbox
          onChange={() => props.onItemClick(props.data)}
          checked={
            props.selectedDocuments.filter(
              (doc) => doc.documentID === props.data.documentID
            ).length > 0
          }
        />
      }
    />
  );
}

export default ItemRequiredReadingDocument;
